<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12">
            <iq-card v-if="patient">
                <template v-slot:headerTitle>
                <h4 class="card-title">Owned devices</h4>
                </template>
                <template v-slot:default>
                  <div v-if="loading">
                    <el-skeleton :rows="5" animated />

                  </div>
                  <div v-else-if="patientDevices.length">
                    <Device :patientDevices="patientDevices"></Device>
                  </div>
                  <div v-else>
                    <el-empty description="No devices." />
                  </div>
                </template>
            </iq-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12">
            <iq-card>
                <template v-slot:headerTitle>
                <h4 class="card-title">Shop devices</h4>
                </template>
                <template v-slot:default>
                    <Purchaseables productType="devices"></Purchaseables>
                </template>
            </iq-card>
            </b-col>
      </b-row>
    </b-container>
</template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import Device from '../../components/Device.vue'
import { xray } from '../../config/pluginInit'
import getDocument from '../../services/getDocument'
import firebase from '../../../firebase'
import getDevices from '../../composables/getDevices'
import { onMounted, ref } from 'vue'
import Purchaseables from '../../components/Purchaseables.vue'

const body = document.getElementsByTagName('body')

export default {
  name: 'ShopDevices',
  components: { IqCard, Device, Purchaseables },
  setup () {
    const firebasePatient = firebase.firebaseAuth.currentUser
    const { document: patient } = getDocument('users', firebasePatient.uid)
    const { getOwnedDevicesByUserId } = getDevices()
    const patientDevices = ref([])
    const loading = ref(true)
    onMounted(async () => {
      loading.value = true
      patientDevices.value = await getOwnedDevicesByUserId(firebasePatient.uid)
      loading.value = false
    })

    return {
      patient,
      patientDevices,
      loading
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

    <style>

    .el-pager {
        margin-top: 15px !important;
    }
    </style>
